import React from 'react';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const AccountsSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <span
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        fill="none"
        x="0px"
        y="0px"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.5 16C34.5 14.6193 33.3807 13.5 32 13.5H18C16.6193 13.5 15.5 14.6193 15.5 16V34C15.5 35.3807 16.6193 36.5 18 36.5H32C33.3807 36.5 34.5 35.3807 34.5 34V16ZM18 15H32C32.5523 15 33 15.4477 33 16V34C33 34.5523 32.5523 35 32 35H18C17.4477 35 17 34.5523 17 34V16C17 15.4477 17.4477 15 18 15ZM29 29.75C29.4142 29.75 29.75 30.0858 29.75 30.5C29.75 30.8797 29.4678 31.1935 29.1018 31.2432L29 31.25H21C20.5858 31.25 20.25 30.9142 20.25 30.5C20.25 30.1203 20.5322 29.8065 20.8982 29.7568L21 29.75H29ZM29.75 27.5C29.75 27.0858 29.4142 26.75 29 26.75H21L20.8982 26.7568C20.5322 26.8065 20.25 27.1203 20.25 27.5C20.25 27.9142 20.5858 28.25 21 28.25H29L29.1018 28.2432C29.4678 28.1935 29.75 27.8797 29.75 27.5ZM23 18C24.6569 18 26 19.3431 26 21C26 22.6569 24.6569 24 23 24C21.3431 24 20 22.6569 20 21C20 19.3431 21.3431 18 23 18ZM21.5 21C21.5 20.1716 22.1716 19.5 23 19.5C23.8284 19.5 24.5 20.1716 24.5 21C24.5 21.8284 23.8284 22.5 23 22.5C22.1716 22.5 21.5 21.8284 21.5 21Z"
          fill={color}
        />
      </svg>
    </span>
  );
};

AccountsSVG.defaultProps = {
  color: getComputedCSSVariable('table-light-gray'),
  style: {
    width: '25px',
    height: '25px',
  },
};

export default AccountsSVG;
